import { useCallback } from "react";
import { identity } from "../utils";
export const useFormikValueOnChange = ({ field, form }, parse = identity) => {
    const { setFieldValue } = form;
    const { name } = field;
    return useCallback((value) => setFieldValue(name, parse(value)), [setFieldValue, name, parse]);
};
//# sourceMappingURL=useFormikValueOnChange.js.map